import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);
/**
 * this.$store.commit('setReportTime', 510000)

 */
const store = new Vuex.Store({
  state: {
    VUE_APP_REPORT_Time: 0, // 报名时间
    VUE_APP_REPORT_END_Time: 0, // 报名结束时间,复赛报名时间
    VUE_APP_Rematch_Time: 0, // 复赛开始报名时间
    VUE_APP_Rematch_End_Time: 0, // 结束复赛报名时间
    deadline_video_date: 0, // 视频上传截至时间
    deadline_video_status: 0, // 视频上传状态 1开启 2关闭
  },
  mutations: {
    // 设置报名时间
    setReportTime(state, value) {
      state.VUE_APP_REPORT_Time = value;
    },
    // 设置报名结束时间,复赛报名时间
    setReportEndTime(state, value) {
      state.VUE_APP_REPORT_END_Time = value;
    },
    setRematchTime(state, value) {
      state.VUE_APP_Rematch_Time = value;
    },
    // 结束复赛报名时间
    setRematchEndTime(state, value) {
      state.VUE_APP_Rematch_End_Time = value;
    },
    // 结束复赛报名时间
    setDeadline_video_date(state, value) {
      state.deadline_video_date = value;
    },
    // 视频上传状态
    setDeadline_video_status(state, value) {
      state.deadline_video_status = value;
    },
  },
  plugins: [createPersistedState()],
});
export default store;
